<template>

    <div>
        <el-divider :content-position="column.dalign" >

            <h1 :style="{color: column.color}" v-if="column.dividerlevel === 1">{{column.label || column.title }}</h1>
            <h2 :style="{color: column.color}" v-else-if="column.dividerlevel === 2">{{column.label || column.title }}</h2>
            <h3 :style="{color: column.color}" v-else>{{column.label || column.title }}</h3>
        </el-divider>

    </div>

</template>
<script>
export default {
  name: 'AvueDivider',
  props: ['column'],
  data() {
    return {
      dicolor: 'red',
      align: 'left'
    }
  },
  updated() {

  }

}
</script>
<style scoped>
/*
 /deep/ .el-divider--horizontal{
     height: 3px
 }*/

</style>
